import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Chip,
  Avatar,
  Tooltip,
  Stack,
  Box,
  Divider,
} from '@mui/material';
import { Person } from '@mui/icons-material';
import { paymentStatusMap } from '../../../components/constants';

const BookingCard = ({ booking, onViewDetails }) => {
  const isCancelled = !!booking.deletedAt;
  const paymentStatus = isCancelled
    ? { label: 'Cancelada', color: 'error' }
    : paymentStatusMap[booking.paymentStatus] || {
        label: 'Desconocido',
        color: 'default',
      };

  return (
    <Card
      elevation={isCancelled ? 1 : 3}
      sx={{
        cursor: 'pointer',
        opacity: isCancelled ? 0.6 : 1,
        '&:hover': { boxShadow: 8, transform: 'translateY(-2px)' },
        transition: 'all 0.3s ease',
      }}
      onClick={() => onViewDetails(booking._id)}
    >
      <CardContent>
        {/* Booking Details Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ color: 'primary.main' }}
            >
              {booking.courtId.type?.toUpperCase()} - {booking.courtId.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', mt: 0.5 }}
            >
              {new Date(booking.dateBooked)
                .toLocaleDateString('es-ES', {
                  weekday: 'long',
                  day: 'numeric',
                  month: 'long',
                  year: 'numeric',
                })
                .replace(/^[a-zñ]/, c => c.toUpperCase())}
            </Typography>
            <Typography
              variant="body2"
              sx={{ color: 'text.secondary', mt: 0.5 }}
            >
              Hora: {booking.timeBooked}
            </Typography>
          </Box>
          <Chip
            label={paymentStatus.label}
            color={paymentStatus.color}
            size="medium"
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Players Section */}
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: 'text.secondary' }}
        >
          Jugadores
        </Typography>
        <Stack direction="row" spacing={2}>
          {booking.players?.map((player, index) => (
            <Tooltip
              key={index}
              title={
                player.isMember
                  ? `${player.memberId?.name || ''} ${player.memberId?.surname || ''}`.trim() ||
                    'Socio'
                  : `${player.nonMemberName || ''} ${player.nonMemberSurname || ''}`.trim() ||
                    'Invitado'
              }
            >
              <Avatar
                src={player.isMember ? player.memberId?.image : ''}
                alt={
                  player.isMember
                    ? `${player.memberId?.name || ''} ${player.memberId?.surname || ''}`.trim()
                    : `${player.nonMemberName || ''} ${player.nonMemberSurname || ''}`.trim() ||
                      'Jugador No Socio'
                }
                sx={{
                  bgcolor: player.isMember ? 'primary.main' : 'secondary.main',
                  color: 'white',
                  width: 48,
                  height: 48,
                  transition: 'all 0.3s ease',
                  '&:hover': { transform: 'scale(1.1)' },
                }}
              >
                {!player.isMember && <Person />}
              </Avatar>
            </Tooltip>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default BookingCard;
